import { render, staticRenderFns } from "./BlockListRteCustom.vue?vue&type=template&id=f78256a8&"
import script from "./BlockListRteCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListRteCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports